module.exports = __webpack_public_path__ + "img/bluenlogo.1071516a.svg";